/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it


import "./src/styles/global.tailwind.css"
import "./src/styles/global.css"
import "animate.css/animate.compat.css"

document.getElementsByTagName("html")[0].classList.add("dark")